export const DateTimeConstants = {
  DEBOUNCE_IN_MS: {
    MS_200: 200,
    MS_250: 250,
    MS_300: 300,
    MS_400: 400,
    MS_500: 500,
    MS_600: 600,
    MS_800: 800,
    MS_1000: 1000,
    MS_2000: 2000,
    MS_3000: 3000
  }
} as const;
